import data from '../block.json';
import "./frontend.scss";


const initializeBlock = (block) => {

    let blockInstance = block;

    if (window.acf) {

        blockInstance = block[0];
    }


        ;


};

const init = () => {
    const {name} = data;

    if (window.acf) {
        window.acf.addAction(`render_block_preview/type=${name}`, initializeBlock);
    } else {
        let blocksOfTypes = document.querySelectorAll('.footer-sofiamed');
        blocksOfTypes.forEach(e => {
            initializeBlock(e);
        });
    }

};

if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
    init();
} else {
    document.addEventListener('DOMContentLoaded', init);
}


